import type {InstagramFollowTriggerStruct} from '@cohort/shared/apps/instagram/triggers/follow';
import type {ActionCtaComponentProps} from '@cohort/wallet/apps/TriggerIntegration';
import OpenCtaUnverified from '@cohort/wallet/components/challenges/OpenCtaUnverified';
import {useTranslation} from 'react-i18next';

const InstagramFollowTriggerActionCtaComponent: React.FC<
  ActionCtaComponentProps<InstagramFollowTriggerStruct>
> = ({config, processStepVerification, trackingMetadata}) => {
  const {t} = useTranslation('app-instagram', {
    keyPrefix: 'triggerIntegrations.follow',
  });

  return (
    <OpenCtaUnverified
      url={config.url}
      ctaTitle={t('ctaTitle')}
      processStepVerification={processStepVerification}
      trackingMetadata={trackingMetadata}
    />
  );
};

export default InstagramFollowTriggerActionCtaComponent;
